import { useCallback, useEffect, useRef, useState } from "react";

/** Re-render every `ms` (relative times, freshness). */
export function useNow(ms = 60_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), ms);
    return () => window.clearInterval(id);
  }, [ms]);
  return now;
}

/**
 * Short-lived confirmation next to a button (admin-17): `flash()` shows it,
 * it hides itself after `ms`.
 */
export function useFlash(ms = 2000): [boolean, () => void] {
  const [visible, setVisible] = useState(false);
  const timer = useRef<number | null>(null);
  useEffect(
    () => () => {
      if (timer.current) window.clearTimeout(timer.current);
    },
    [],
  );
  const flash = useCallback(() => {
    setVisible(true);
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setVisible(false), ms);
  }, [ms]);
  return [visible, flash];
}
